import { IconGamblersAnonymous } from 'components/icons/icons-footer/icon-gamblers-anonymous';
import { IconGamecare } from 'components/icons/icons-footer/icon-gamecare';
import { IconFacebook } from 'components/icons/icons-social/icon-facebook';
import { IconInstagram } from 'components/icons/icons-social/icon-instagram';
import { IconTwitter } from 'components/icons/icons-social/icon-twitter';
import { IconTiktok } from 'components/icons/icons-social/icon-tiktok';
import { IconPinterest } from 'components/icons/icons-social/icon-pinterest';
import { IconTelegram } from 'components/icons/icons-social/icon-telegram';
import { IconYouTube } from 'components/icons/icons-social/icon-youtube';
import { IconReddit } from 'components/icons/icons-social/icon-reddit';

import { IconVisa } from 'components/icons/icons-footer/icon-visa';
import { IconMastercard } from 'components/icons/icons-footer/icon-mastercard';
import { IconMaestro } from 'components/icons/icons-footer/icon-maestro';
import { IconBankTransferWhite } from 'components/icons/icons-footer/icon-bank-transfer-white';
import { IconMefete } from 'components/icons/icons-footer/icon-mefete';
import { IconPapara } from 'components/icons/icons-footer/icon-papara';
import { IconPep } from 'components/icons/icons-footer/icon-pep';
import { IconBitcoin } from 'components/icons/icons-footer/icon-bitcoin';
import { IconTether } from 'components/icons/icons-footer/icon-tether';
import { IconLitecoin } from 'components/icons/icons-footer/icon-litecoin';
import { IconEthereum } from 'components/icons/icons-footer/icon-ethereum';
import classNames from 'classnames';
import React from 'react';
import { MODAL_IDS } from '../../constants';

export const footerMenu = [
  {
    title: 'footer.link.games',
    link: '/games',
  },
  {
    title: 'footer.link.live',
    link: '/games/live',
  },
  {
    title: 'footer.link.slot-games',
    link: '/games/slot',
  },
  {
    title: 'footer.link.promos',
    link: '/promos',
  },
  {
    title: 'footer.link.tournaments',
    link: '/tournaments',
  },
];

export const footerInfo = [
  [
    {
      title: 'footer.link.payments',
      link: '/payments',
    },
    {
      title: 'footer.link.support',
      modalId: MODAL_IDS.SUPPORT,
    },
    {
      title: 'footer.link.about',
      link: '/about',
    },
    {
      title: 'footer.link.terms',
      link: '/terms',
    },
    // {
    //   title: 'footer.link.aml',
    //   link: '/anti-money-laundering',
    // },
    // {
    //   title: 'footer.link.refund-policy',
    //   link: '/refund-policy',
    // },
    // {
    //   title: 'footer.link.privacy-policy',
    //   link: '/privacy-policy',
    // },
    // {
    //   title: 'footer.link.become-vip',
    //   link: '/become-vip',
    // },
  ],
  [
    {
      title: 'footer.link.affiliates',
      link: '/affiliate',
    },
    {
      title: 'footer.link.responsible-gaming',
      link: '/responsible-gaming',
    },
    {
      title: 'footer.link.faq',
      link: '/faq',
    },
    // {
    //   title: 'footer.link.self-exclusion',
    //   link: '/self-exclusion',
    // },
    // {
    //   title: 'footer.link.dispute-resolution',
    //   link: '/dispute-resolution',
    // },
    // {
    //   title: 'footer.link.fairness-and-rng',
    //   link: '/fairness-and-rng',
    // },
    {
      title: 'footer.link.kyc',
      link: '/kyc',
    },
    // {
    //   title: 'footer.link.betting-rules',
    //   link: '/betting-rules',
    // },
    {
      title: 'footer.link.bonus-terms',
      link: '/bonus-terms',
    },
    {
      title: 'footer.link.bet-rules',
      link: '/bet-rules',
    },
    {
      title: 'footer.link.underage-gaming',
      link: '/underage-gaming',
    },
    {
      title: 'footer.link.self-exclusion',
      link: '/self-exclusion',
    },
  ]
];

export const footerPaymentIcons = [
  {
    title: 'Visa',
    icon: IconVisa,
  },
  {
    title: 'Mastercard',
    icon: IconMastercard,
  },
  {
    title: 'Maestro',
    icon: IconMaestro,
  },
  {
    title: 'BankTransfer',
    icon: IconBankTransferWhite,
  },
  {
    title: 'Payfix',
    // eslint-disable-next-line react/prop-types
    icon: ({ className }) => <img className={classNames('footer-icon', className)} src="/assets/public/images/footer-icons/payfix.png" alt="payfix-icon" />,
  },
  {
    title: 'Mefete',
    icon: IconMefete,
  },
  {
    title: 'Papara',
    icon: IconPapara,
  },
  {
    title: 'Pep',
    icon: IconPep,
  },
  {
    title: 'Bitcoin',
    icon: IconBitcoin,
  },
  {
    title: 'Tether',
    icon: IconTether,
  },
  {
    title: 'Litecoin',
    icon: IconLitecoin,
  },
  {
    title: 'Ethereum',
    icon: IconEthereum,
  },
];

export const footerIconsWithLink = [
  {
    title: 'Gamecare',
    Icon: IconGamecare,
    link: 'https://www.gamblingtherapy.org/en',
  },
  {
    title: 'GamblersAnonymous',
    Icon: IconGamblersAnonymous,
    link: 'https://www.gamblersanonymous.org.uk',
  },
];

export const getFooterSocialIconsWithLink = formatMessage => [
  {
    id: 'facebook',
    Icon: IconFacebook,
    link: formatMessage({ id: 'footer.social.url.facebook', defaultMessage: 'none' }),
  },
  {
    id: 'twitter',
    Icon: IconTwitter,
    link: formatMessage({ id: 'footer.social.url.twitter', defaultMessage: 'none' }),
  },
  {
    id: 'instagram',
    Icon: IconInstagram,
    link: formatMessage({ id: 'footer.social.url.instagram', defaultMessage: 'none' }),
  },
  {
    id: 'tiktok',
    Icon: IconTiktok,
    link: formatMessage({ id: 'footer.social.url.tiktok', defaultMessage: 'none' }),
  },
  {
    id: 'pinterest',
    Icon: IconPinterest,
    link: formatMessage({ id: 'footer.social.url.pinterest', defaultMessage: 'none' }),
  },
  {
    id: 'telegram',
    Icon: IconTelegram,
    link: formatMessage({ id: 'footer.social.url.telegram', defaultMessage: 'none' }),
  },
  {
    id: 'youtube',
    Icon: IconYouTube,
    link: formatMessage({ id: 'footer.social.url.youtube', defaultMessage: 'none' }),
  },
  {
    id: 'reddit',
    Icon: IconReddit,
    link: formatMessage({ id: 'footer.social.url.reddit', defaultMessage: 'none' }),
  },
];
